// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function AppleLogoBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M28.879 23a1.5 1.5 0 0 0-.527-.637C26.41 21.027 26.004 18.71 26.004 17c0-2.02 1.585-3.825 2.53-4.72a1.5 1.5 0 0 0 0-2.178c-1.67-1.58-4.43-2.602-7.03-2.602a9.536 9.536 0 0 0-5 1.422 9.449 9.449 0 0 0-11.698 1.375 9.83 9.83 0 0 0-2.802 7.142A16.375 16.375 0 0 0 7.182 29a5.476 5.476 0 0 0 3.772 1.5h10.96a5.484 5.484 0 0 0 4.007-1.73 15.952 15.952 0 0 0 2.3-3.175c.196-.36.375-.713.518-1.05.198-.46.405-.936.14-1.545Zm-5.154 3.727a2.473 2.473 0 0 1-1.81.772H10.954a2.482 2.482 0 0 1-1.713-.677 13.397 13.397 0 0 1-4.237-9.463 6.81 6.81 0 0 1 1.937-4.95 6.356 6.356 0 0 1 4.563-1.91h.09a6.438 6.438 0 0 1 3.97 1.425 1.5 1.5 0 0 0 1.875 0 6.426 6.426 0 0 1 4.065-1.425c1.3.016 2.578.332 3.735.925-1.453 1.783-2.235 3.717-2.235 5.575 0 2.917.933 5.362 2.656 7.024a12.908 12.908 0 0 1-1.936 2.703ZM16.597 3.624a5.48 5.48 0 0 1 1.678-1.436 1.5 1.5 0 0 1 1.455 2.625 2.48 2.48 0 0 0-.764.655 1.501 1.501 0 0 1-2.369-1.844Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
